<template>
  <div
    id="end-container"
    v-if="showEndData && presentation.callToActionEnable === 1"
  >
    <div id="relative-container">
      <div id="container-content">
        <template v-if="presentation.callToActionType === 1">
          <div id="form-container" v-show="showEndData">
            <i class="el-icon-close" @click="handleClose"></i>
            <div id="form-container-header">
              <h2>{{ callToActionTitle.val }}</h2>
            </div>
            <el-form
              :model="form"
              :rules="formRules"
              ref="formDom"
              label-width="100px"
              style="color: #fff"
            >
              <el-form-item
                :label="_cI18n('presentation.end.form.name')"
                prop="name"
              >
                <el-input
                  v-model="form.name"
                  @focus="isFocus = true"
                  @input="isInput = true"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="_cI18n('presentation.end.form.email')"
                prop="email"
              >
                <el-input
                  v-model="form.email"
                  @focus="isFocus = true"
                  @input="isInput = true"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="item.name"
                v-for="item in formDataOptional"
                :key="item.uid"
              >
                <el-input
                  v-model="item.val"
                  @focus="isFocus = true"
                  @input="isInput = true"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="handleSubmit"
                style="width: 100%"
                >{{ _cI18n("presentation.end.send") }}</el-button
              >
            </el-form>
            <!-- 下划线 -->
            <div
              id="content-box-title"
              v-if="presentation ? presentation.userInfoEnable === 1 : false"
            >
              {{ _cI18n("presentation.end.contactUs") }}
            </div>
            <div
              class="content-box"
              v-if="presentation ? presentation.userInfoEnable === 1 : false"
            >
              <span
                >{{ _cI18n("presentation.end.email") }}:
                {{ presentation.contactEmail }}</span
              >
              <span class="ml-3"
                >{{ _cI18n("presentation.end.phone") }}:
                {{ formatPhone(presentation.contactPhone) }}</span
              >
            </div>
            <div class="content-option-box">
              <span v-for="item in userInfoConfig" :key="item.uid">
                {{ item.name }}:
                {{ item.val }}
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div id="btnLink-container">
            <h2 v-if="linkData.title">{{ linkData.title }}</h2>
            <p v-if="linkData.description">{{ linkData.description }}</p>
            <button
              class="link-btn"
              :style="{
                background: linkData.buttonColor
                  ? linkData.buttonColor
                  : '#2793FF',
                color: linkData.textColor ? linkData.textColor : '#fff',
              }"
              @click="goLink"
            >
              {{
                linkData.buttonText
                  ? linkData.buttonText
                  : _cI18n("presentation.end.btnText")
              }}
            </button>
          </div>
        </template>
        <div class="recommand-video-container" v-if="refVideos.length">
          <div id="recommand-video-container-title">
            {{ _cI18n("presentation.end.recommendedVideo") }}
          </div>
          <div id="refVideo-list" v-if="refVideos.length">
            <div
              v-for="item in refVideos"
              :key="item.id"
              class="list-item"
              @click="handleClickRefVideo(item)"
            >
              <div class="list-resource">
                <img
                  :src="item.presentationReferVideo.presentationDetail[0].url"
                  alt=""
                  class="item-img"
                  v-if="
                    checkIsImage(
                      item.presentationReferVideo.presentationDetail[0].url
                    )
                  "
                />
                <video
                  :src="item.presentationReferVideo.presentationDetail[0].url"
                  class="item-video"
                  style="width: 100%"
                  v-else-if="
                    checkIsVideo(
                      item.presentationReferVideo.presentationDetail[0].url
                    )
                  "
                ></video>
                <div class="item-iframe" v-else>
                  <iframe
                    :src="item.presentationReferVideo.presentationDetail[0].url"
                    id="iframe_container"
                    frameborder="0"
                    webkitallowfullscreen=""
                    mozallowfullscreen=""
                    allowfullscreen=""
                    allow="autoplay;fullscreen"
                    width="600"
                    height="600"
                    class="select-none"
                  >
                  </iframe>
                </div>
              </div>
              <div class="item-info-box">
                <div class="item-name">
                  <div class="text" :style="{ WebkitBoxOrient: 'vertical' }">
                    {{ item.presentationReferVideo.name }}
                  </div>
                  <div class="item-user">
                    <img :src="presentation.user.avatarUrl" />
                    <span>{{ presentation.user.name }}</span>
                  </div>
                </div>
                <div class="item-count">
                  <el-tooltip
                    effect="dark"
                    :content="_cI18n('presentation.end.impression')"
                    placement="bottom"
                  >
                    <span>{{ presentation.impressionCount }}</span>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="_cI18n('presentation.end.playCount')"
                    placement="bottom"
                  >
                    <span>{{ presentation.playCount }}</span>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="_cI18n('presentation.end.createdAt')"
                    placement="bottom"
                  >
                    <span>{{
                      $dayjs(presentation.createdAt).format("YYYY-MM-DD")
                    }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full mt-5" v-else>
            {{ _cI18n("presentation.end.noData") }}
          </div>
        </div>
        <div class="icon-box">
          <div @click="reloadPPT">
            <i class="el-icon-refresh-right"></i>
            {{ _cI18n("presentation.end.reload") }}
          </div>
          <div @click="sharePPT">
            <i class="el-icon-share"></i>
            {{ _cI18n("presentation.end.share") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $postHttp } from "@/utils/request";
import { apiUrl } from "@/utils/global";
import {
  getPresentationReferVideos,
  createPresentationContact,
} from "@/graphql/presentation";
import { cI18n } from "@/utils/cI18n";
export default {
  data() {
    const checkPhone = (rule, val, callback) => {
      const reg = /(?:^1[3456789]|^9[28])\d{9}$/;
      if (!reg.test(val))
        callback(new Error(cI18n("presentation.end.phoneNoValid")));
      callback();
    };

    const checkEmail = (rule, val, callback) => {
      const reg = /^\b[a-z_0-9.-]{1,64}@([a-z0-9-]{1,200}.){1,5}[a-z]{1,6}$/i;
      if (!val) callback(new Error(cI18n("presentation.end.emailRequired")));
      if (!reg.test(val))
        callback(new Error(cI18n("presentation.end.emailNoValid")));
      callback();
    };

    return {
      form: {
        name: "",
        email: "",
        company: "",
        phone: "",
        message: "",
      },
      formRules: {
        name: [
          {
            required: true,
            message: cI18n("presentation.end.nameRequired"),
            trigger: "blur",
          },
        ],
        email: [
          {
            validator: checkEmail,
            required: true,
            trigger: "blur",
          },
        ],
        phone: {
          trigger: "blur",
          validator: checkPhone,
        },
      },
      refVideos: [],
      presentationId: "",
      presentationData: [],
      presentation: {},
      formDataRequired: [],
      formDataOptional: [],
      linkData: {},
      callToActionTitle: {},
      itemH: 90,
      isFocus: false,
      isInput: false,
      userInfoConfig: [],
    };
  },
  props: {
    showEndData: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit("closeEndData");
      this.isFocus = false;
      this.isInput = false;
    },
    reloadPPT() {
      this.$emit("reloadPPT");
    },
    sharePPT() {
      this.$emit("sharePPT");
    },
    //关闭定时器防止弹窗关闭
    closeTimer() {
      this.$emit("closeTimerToShowEndData");
    },
    resetFields() {
      this.$refs.formDom.resetFields();
    },
    handleSubmit() {
      this.$refs.formDom.validate((valid) => {
        // console.log(valid);
        if (valid) {
          this._createPresentationContact();
        }
      });
    },
    _getPresentationReferVideos() {
      $postHttp(`${apiUrl}/graphql`, {
        data: {
          query: getPresentationReferVideos,
          variables: {
            presentationId: this.presentationId,
          },
        },
      }).then((res) => {
        const {
          data: { getPresentationReferVideos },
        } = res;
        this.refVideos = getPresentationReferVideos;
      });
    },
    _cI18n(text) {
      return cI18n(text);
    },
    _createPresentationContact() {
      $postHttp(`${apiUrl}/graphql`, {
        data: {
          query: createPresentationContact,
          variables: {
            presentationContact: {
              ...this.form,
              presentationId: this.presentationId,
            },
          },
        },
      }).then((res) => {
        this.$message.success(cI18n("presentation.end.ThankSupport"));
        this.handleClose();
      });
    },
    getPresentationId(id, presentation) {
      this.presentationId = id;
      this.presentationData = presentation.data.getSharePresentationDetails;
      this.presentation = this.presentationData[0].presentation;
      if (this.presentation.callToActionLinkConfig) {
        this.linkData = JSON.parse(this.presentation.callToActionLinkConfig);
      }

      if (this.presentation.callToActionTableConfig) {
        const callToActionTableConfig = JSON.parse(
          this.presentation.callToActionTableConfig
        );
        const requiredFormItems = [];
        const optionalFormItems = [];
        callToActionTableConfig.forEach((a) => {
          if (a.name === "title") {
            this.callToActionTitle = a;
            return;
          }
          if (a.required) {
            requiredFormItems.push(a);
          } else {
            optionalFormItems.push(a);
          }
        });
        this.formDataRequired = requiredFormItems;
        this.formDataOptional = optionalFormItems;
      }

      if (this.presentation.userInfoConfig) {
        this.userInfoConfig = JSON.parse(this.presentation.userInfoConfig);
      }
      this._getPresentationReferVideos();
    },
    checkIsImage(url) {
      const imgType = [
        "jpg",
        "JPG",
        "PNG",
        "png",
        "jpeg",
        "JPNG",
        "BMP",
        "bmp",
        "svg",
        "gif",
        "webp",
      ];
      return imgType.includes(
        url.split(".")[url.split(".").length - 1].toLowerCase()
      );
    },
    checkIsVideo(url) {
      return [
        "mov",
        "mp4",
        "avi",
        "flv",
        "3gp",
        "webm",
        "rmvb",
        "wmv",
        "asf",
        "asx",
        "vob",
        "dat",
        "mkv",
      ].includes(url.split(".")[url.split(".").length - 1].toLowerCase());
    },
    handleClickRefVideo(item) {
      // console.log(item);
      const shareUUID = item.presentationReferVideo.shareUUID;
      window.location.href = `${window.location.origin}/sharepresentation/?s=${shareUUID}`;
    },
    formatPhone(phone) {
      const str1 = phone.slice(0, 3);
      const str2 = phone.slice(3, 7);
      const str3 = phone.slice(7);
      return str1 + "-" + str2 + "-" + str3;
    },
    goLink() {
      if (this.linkData.buttonLink) {
        window.open(this.linkData.buttonLink);
      } else {
        this.$message.error(cI18n("presentation.end.errorLink"));
      }
    },
  },
  watch: {
    isFocus(nv, ov) {
      if (nv) {
        // console.log("聚焦了");
        this.closeTimer();
      }
    },
    isInput(nv, ov) {
      if (nv) {
        // console.log("输入了");
        this.closeTimer();
      }
    },
  },
  mounted() {
    this.$bus.$on("getPresentation", this.getPresentationId);
  },
  beforeDestroy() {
    this.$bus.$off("getPresentation", this.getPresentationId);
  },
};
</script>
<style scoped>
#end-container {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500;
  display: flex;
}

#relative-container {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
}

#container-content {
  width: 1000px;
  display: flex;
  align-items: center;
  position: relative;
}

#end-container-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#form-container {
  width: 40%;
  min-width: 345px;
  padding: 20px;
  border-radius: 8px;
  background: rgb(31, 39, 61, 0.85);
  position: relative;
}

.el-icon-close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

#btnLink-container {
  width: 40%;
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: center;
  margin-bottom: 250px;
}

.link-btn {
  width: 200px;
  background: #2793ff;
  outline: none;
  padding: 20px;
  color: #fff;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 1.2rem;
}

.recommand-video-container {
  margin-left: 50px;
}

.recommand-video-container #recommand-video-container-title {
  text-align: left;
  width: 100%;
  font-size: 1.125rem;
  margin-top: 30px;
}

.recommand-video-container #refVideo-list {
  width: 30rem;
  max-height: 400px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: auto;
}

.item-info-box {
  display: flex;
  flex-direction: column;
}

#refVideo-list .list-item {
  cursor: pointer;
  display: flex;
  margin-top: 10px;
}

.list-resource {
  height: 90px;
  width: 220px;
  overflow: hidden;
  border-radius: 8px;
}

#refVideo-list .list-item .item-name {
  text-align: left;
  margin-left: 10px;
  width: 180px;
}

#refVideo-list .list-item .item-video,
.item-img,
.item-iframe {
  width: 100%;
}

#refVideo-list .list-item .item-iframe {
  height: 4rem;
  overflow: hidden;
}

.item-name .text {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-name .item-user {
  display: flex;
  align-items: center;
}
.item-name .item-user img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.item-name .item-user span {
  margin-left: 10px;
}

.item-count {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.item-count span {
  margin-left: 10px;
}

.icon-box {
  display: flex;
  position: absolute;
  top: 30%;
  right: 0;
  transform: translateY(-50%);
  font-size: 1.2rem;
}

.icon-box div {
  cursor: pointer;
}

.icon-box div:last-child {
  margin-left: 10px;
}

#content-box-title {
  text-align: center;
  font-size: 1.2rem;
  margin-top: 8px;
}

.content-box,
.content-option-box {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.content-option-box {
  margin-top: 0;
}

.content-box span,
.content-option-box span {
  text-align: left;
  margin-top: 3px;
}

::v-deep .el-form-item__label {
  color: #fff;
}

::v-deep .el-dialog__header {
  text-align: center;
}
::v-deep .el-dialog__title {
  color: #fff;
}

::v-deep .el-dialog__body {
  color: #fff;
  text-align: left;
}
::v-deep .el-dialog,
.el-pager li {
  background: rgb(31, 39, 61, 0.85);
}

/* 滚动条样式 */

::-webkit-scrollbar {
  width: 10px;
  height: 6px;
  position: relative;
}

/*滚动条里面轨道*/

::-webkit-scrollbar-track {
  background: transparent;
}

/*滚动条里面小方块*/

::-webkit-scrollbar-thumb {
  height: 50px;
  min-width: 50px;
  background: transparent;
  transition: all 0.6s;
  cursor: pointer;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: #515151;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
</style>